import React from 'react';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import './Contact.css';

const Contact = () => {

    return (
        <div className='bg-white'>
            <NavBar />

            <div className="container d-flex flex-column justify-content-center align-items-center mb-5">
                {/* avatar */}
                <div className='d-flex flex-column justify-content-center align-items-center'>
                    <img src={'/img_about_an.png'} alt="avatar" style={{ height: '40vh' }} className='align-self-center justify-content-center d-block mx-auto' />
                    <h1
                        style={{
                            fontSize: 'clamp(1.2rem, 2vw, 1.5rem)'
                        }}
                        className='mt-5 mx-5'
                    >
                        An Classical là một con người đam mê âm nhạc, khởi đầu bằng những bản piano cổ điển. Sau khoảng thời gian học hỏi và tích luỹ kinh nghiệm, nhận thấy nhiều bạn tự tìm hiểu và học piano nhưng chưa biết bắt đầu từ đâu. An và đội ngũ đã quyết định tạo ra website anclassical.com để giải quyết vấn đề trên.
                    </h1>
                </div>
            </div>

            <div className='bg-black d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
                <div className='custom-container p-5'>
                    <h1
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                            textAlign: 'left'
                        }}
                        className='text-dancing-script mt-3 text-white'
                    >
                        Website được tạo ra để kết nối những tâm hồn yêu âm nhạc, cung cấp kho tàng kiến thức âm nhạc phong phú từ cơ bản đến nâng cao. Với châm ngôn "Thanh âm đến từ trái tim”. Hãy cùng An Classical biến những giai điệu trong bạn trở thành thanh âm lan tỏa khắp mọi nơi!
                    </h1>

                    <h1
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1rem, 2vw, 1.5rem)'
                        }}
                        className='text-dancing-script mt-3 text-white mt-5'
                    >
                        Kết nối với An Classical tại:
                    </h1>

                    <div className="d-flex flex-row justify-content-center gap-2 mt-3">
                        <Link to="#">
                            <img
                                src={'/tiktok_logo_white.png'}
                                alt="tiktok"
                                width="50"
                                height="50"
                                className="me-3 social-icon"
                            />
                        </Link>
                        <Link to="#">
                            <img
                                src={'/fb_logo.png'}
                                alt="facebook"
                                width="50"
                                height="50"
                                className='me-3 social-icon'
                            />
                        </Link>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Contact